<template>
    <button type="button" class="py-1 font-bold text-white">
        <slot></slot>
    </button>
</template>
